// extracted by mini-css-extract-plugin
module.exports = {"accordionContent":"Accordion_accordionContent__YdTsq","header":"Accordion_header__4SJbU","item":"Accordion_item__I57NX","expanded":"Accordion_expanded__I6MZq"};